import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useVersion } from '../hooks/queries/useVersion';
import { useAuth } from '../contexts/AuthContext';
import { isAdminUser } from '../utils/tier-utils';
import { ReleaseNotesDialog } from './ReleaseNotesDialog';
import { cn } from '../utils/cn';

export interface FooterProps {
  /** Extra classes, e.g. bottom padding to clear the mobile tab bar on AppShell routes. */
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className }) => {
  const { data: versionData } = useVersion();
  const { user } = useAuth();
  const frontendCommit = process.env.REACT_APP_COMMIT_HASH || 'unknown';
  const backendCommit = versionData?.commit || '...';
  const isAdmin = isAdminUser(user);

  const [showReleaseNotes, setShowReleaseNotes] = useState(false);

  const versionButtonClass =
    'font-mono tabular underline decoration-dotted underline-offset-2 hover:text-ink';

  return (
    <>
      <footer className={cn('mt-auto w-full border-t border-line py-4 text-center text-xs text-muted', className)}>
        <div className="mx-auto max-w-wide px-4">
          <div className="mb-2 flex justify-center gap-4">
            <Link to="/impressum" className="hover:underline">Impressum</Link>
            <Link to="/datenschutz" className="hover:underline">Datenschutz</Link>
            <Link to="/agb" className="hover:underline">AGB</Link>
            <Link to="/widerruf" className="hover:underline">Widerruf</Link>
          </div>
          <div className="flex flex-wrap justify-center gap-x-4">
            <span>
              Frontend:{' '}
              {isAdmin ? (
                <button
                  type="button"
                  className={versionButtonClass}
                  onClick={() => setShowReleaseNotes(true)}
                  title="Release Notes anzeigen"
                >
                  {frontendCommit}
                </button>
              ) : (
                <span className="font-mono tabular">{frontendCommit}</span>
              )}
            </span>
            <span>
              Backend:{' '}
              {isAdmin ? (
                <button
                  type="button"
                  className={versionButtonClass}
                  onClick={() => setShowReleaseNotes(true)}
                  title="Release Notes anzeigen"
                >
                  {backendCommit}
                </button>
              ) : (
                <span className="font-mono tabular">{backendCommit}</span>
              )}
            </span>
          </div>
        </div>
      </footer>
      {isAdmin && showReleaseNotes && (
        <ReleaseNotesDialog onClose={() => setShowReleaseNotes(false)} />
      )}
    </>
  );
};

export default Footer;
